import { render, staticRenderFns } from "./myPopup.vue?vue&type=template&id=28989af8&scoped=true"
import script from "./myPopup.vue?vue&type=script&lang=js"
export * from "./myPopup.vue?vue&type=script&lang=js"
import style0 from "./myPopup.vue?vue&type=style&index=0&id=28989af8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28989af8",
  null
  
)

export default component.exports